import React from 'react';
import { alertEventIds } from '#component/user/notification/helper';
import { DescriptionItem, NotificationLink } from './styles';

function NotificationDescription({ notification, handleReadNotification }) {
  const { alert, device, log, appliance, shipment } = notification;
  const isAlertEvent = alertEventIds.includes(log.eventId);
  const linkText = appliance?.label || shipment?.label;
  const linkUrl = appliance ? `/warehouse/appliance-overview/${appliance.id}` : `/shipment/${shipment?.id}`;

  if (!isAlertEvent) {
    return 'Not recognized event';
  }

  return (
    <>
      <DescriptionItem>
        Alert
        {' '}
        &quot;
        {alert.label}
        &quot;
        {' '}
        triggered by
        {' '}
        {device.title}
      </DescriptionItem>
      <DescriptionItem>
        <NotificationLink
          to={linkUrl}
          target="_blank"
          onAuxClick={handleReadNotification}
        >
          {linkText}
        </NotificationLink>
      </DescriptionItem>
    </>
  );
}

export default NotificationDescription;
